exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sidenav---sidenav---_2tBP .nav-link.active{\n    color: green !important;\n    font-weight: bold;\n}\n\n#TMMemberSideNav .sidenav---sidenav---_2tBP {\n    background: green !important;\n}\n", ""]);

